/**
 * @generated SignedSource<<362a1c55530deb6358d27bb771916187>>
 * @relayHash ddcb713faea6264b16dad4287cf3b4b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type AdminKeyEligibilityQueryAdminKeyEligibilityQuery$variables = Record<PropertyKey, never>;
export type AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data = {
  readonly confluenceTenantContext: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
  } | null;
  readonly tenant: {
    readonly cloudId: string;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly roles: {
        readonly canBeSuperAdmin: boolean;
      } | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type AdminKeyEligibilityQueryAdminKeyEligibilityQuery = {
  response: AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data;
  variables: AdminKeyEligibilityQueryAdminKeyEligibilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "Tenant",
    "kind": "LinkedField",
    "name": "tenant",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "cloudId"
      }
    ]
  },
  {
    "alias": "confluenceTenantContext",
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLConfluenceUserRoles",
            "kind": "LinkedField",
            "name": "roles",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canBeSuperAdmin"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ddcb713faea6264b16dad4287cf3b4b4",
    "id": "9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad",
    "metadata": {},
    "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
    "operationKind": "query",
    "text": "query AdminKeyEligibilityQueryAdminKeyEligibilityQuery{tenant{cloudId},confluenceTenantContext:confluence_tenantContext{editions{confluence}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
  }
};
})();

(node as any).hash = "f9719ea98536123f3036cf46919010ba";

export default node;
